import * as React from "react"

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { StaticImage } from "gatsby-plugin-image"


// import Arabic from "../../images/images/languages/arabic.png"
// import English from "../../images/images/languages/english.png"
// import Spanish from "../../images/images/languages/spanish.png"
// import French from "../../images/images/languages/french.png"

import EmailIcon from '@mui/icons-material/Send';

const SectionTen= () => {
    
    const [state, setState] = React.useState({})

    const handleChange = e => {
        setState({ ...state, [e.target.name]: e.target.value })
      }

    function encode(data) {
        return Object.keys(data)
          .map(
            (key) =>
              encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
          )
          .join("&");
      }
    const handleSubmit = (e) => {
        e.preventDefault();
        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: encode({
            "form-name": e.target.getAttribute("name"),
            ...state,
            }),
        })
        .then(() => toast.success("Form successfully submitted"))
        .then(
          document.getElementById("subscriptForm").reset()
        )
        .catch((error) => toast.error("error" + error));
      };

    return(
    <>
        <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            />
        <footer className="footer bggreay" id="footer">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-6">
                        <aside className="widget">
                            <div className="textWidget">
                                {/* <div className="flogow">
                                    <div className="flogo">
                                        <a href="index.html"><img src={Alicante} alt="" /></a>
                                    </div>
                                    <div className="logo logoText hidden">
                                        <h1><a href="index.html">Rhoni Vision</a></h1>
                                    </div>
                                </div> */}
                                <h3 className="widgetTitle">About <b>Rhoni Vision</b></h3>
                                <p>Please contact Rhoni Vision to schedule a FREE consultation and learn how we can help you expand
your company's brand and sales. We are excited to collaborate with you and share your unique story
together!</p>
                                <div className="socialIcon">
                                    <a className="fb" href="https://www.facebook.com/RhoniVisionProduction" title="Rhoni vision video production facebook page" target='_blank' rel="noreferrer"><i aria-label="Rhoni vision video production facebook page" role="button" className="fa fa-facebook"></i></a>
                                    <a className="tw" href="https://twitter.com/RhoniVision" title="Rhoni vision video production Twitter page" target='_blank' rel="noreferrer"><i aria-label="Rhoni vision video production Twitter page" role="button" className="fa fa-twitter"></i></a>
                                    <a className="gp" href="https://www.linkedin.com/in/rhoni-jaefar-creative-director-and-producer-38577469/" title="Rhoni vision video production Linkedin page" target='_blank' rel="noreferrer"><i aria-label="Rhoni vision video production Linkedin page" role="button" className="fa fa-linkedin"></i></a>
                                    <a className="dr" href="https://www.instagram.com/rhonivisionprod/" title="Rhoni vision video production Instagram page" target='_blank' rel="noreferrer"><i aria-label="Rhoni vision video production Instagram page" role="button" className="fa fa-instagram"></i></a>
                                    <a className="be" href="https://www.youtube.com/channel/UC0MHoFphDY6Dvxfk4ttaYuA?sub_confirmation=1" title="Rhoni vision video production Youtube page" target='_blank' rel="noreferrer"><i aria-label="Rhoni vision video production Youtube page" role="button" className="fa fa-youtube"></i></a>
                                </div>
                            </div>
                        </aside>
                    </div>
                    <div className="col-sm-6">
                        <aside className="widget">
                            <div className="newsletterwid">
                                <h3 className="widgetTitle">Newsletter <b>Signup</b></h3>
                                <div className="newsletter">
                                    <form id="subscriptForm" name="newsletter" method="POST" data-netlify="true" onSubmit={handleSubmit}>
                                        <input type="hidden" name="form-name" value="newsletter" />
                                        <input type="email" name="sub_email" id="sub_email" placeholder="Enter your email address."  required onChange={handleChange}/>
                                        <input type="submit" name="sub_submit" id="sub_submit" value="SUBSCRIBE" />
                                    </form>
                                </div>
                                <div className="fooInfo">
                                    <p><i className="flaticon-pin"></i><b>Head office:</b> Flexspace, Office 30, Manchester Road <br/>BL3 2NZ, Bolton - United Kingdom</p>
                                    <br/>
                                    <p><i className="flaticon-technology"></i><b><a href="tel:+441615052760">+44 161 50 52 760</a></b></p>
                                    <br/>
                                    <p><EmailIcon/><b>&nbsp;&nbsp;<a href="mailto:contact@rhonivision.com">contact@rhonivision.com</a></b></p>
                                    <br/>
                                    <div>
                                        <p>We speak your language</p>
                                        <br/>
                                        <StaticImage src="../../images/images/languages/english.png" alt="Rhoni vision production's team speaks English" title="English"/>&nbsp;&nbsp;&nbsp;&nbsp;
                                        <StaticImage src="../../images/images/languages/french.png" alt="Rhoni vision production's team speaks French" title="French"/>&nbsp;&nbsp;&nbsp;&nbsp;
                                        <StaticImage src="../../images/images/languages/spanish.png" alt="Rhoni vision production's team speaks Spanish" title="Spanish"/>&nbsp;&nbsp;&nbsp;&nbsp;
                                        <StaticImage src="../../images/images/languages/arabic.png" alt="Rhoni vision production's team speaks Arabic" title="Arabic"/>&nbsp;&nbsp;&nbsp;&nbsp;
                                    </div>
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        </footer>
        <section className="copyright">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 text-center">
                        
                        <p className="copyPera">{new Date().getFullYear()} All Rights Reserved Rhoni Vision Production.</p>
                        <p>Registered Number: 11732223&nbsp; |&nbsp; VAT Number:GB123456789</p>
                    </div>
                </div>
            </div>
        </section>    
    </>
)
}
export default SectionTen